/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M7 10.5c2.4853 0 4.5-2.0147 4.5-4.5S9.4853 1.5 7 1.5 2.5 3.5147 2.5 6s2.0147 4.5 4.5 4.5ZM7 12a5.9739 5.9739 0 0 0 3.6792-1.2601L16.4393 16.5l-6.2196 6.2197a.7499.7499 0 0 0 0 1.0606.75.75 0 0 0 1.0606 0L17.5 17.5607 20.9393 21l-1.7196 1.7197a.75.75 0 0 0 0 1.0606.75.75 0 0 0 1.0606 0l2.25-2.25.5304-.5303-.5304-.5303-4.4996-4.4996a.0008.0008 0 0 0-.0004-.0004.0008.0008 0 0 0-.0004-.0004l-6.29-6.29A5.974 5.974 0 0 0 13 6c0-3.3137-2.6863-6-6-6S1 2.6863 1 6s2.6863 6 6 6Z"
    clipRule="evenodd"
  />,
  'Key'
);
